// libraries
import React, { useState } from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'
import Video from '/react4xp/components/Video'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import SectionDivider from '../SectionDivider'

// prop types
interface ListVideosProps {
    disableDivider?: boolean
    title?: string
    videos?: Array<{
        playText: string
        videoType: 'youtube' | 'vimeo' | 'default'
        poster: string
        url: string
        title?: string
        cookieConsentHtml?: string
    }>
    bottomLink?: {
        hasPagination: boolean 
        text: string
        href?: string
        external?: boolean
    }
    howManyItems: number
}

export default function ListVideos({
    disableDivider = false,
    title,
    videos = [],
    bottomLink,
    howManyItems
}: ListVideosProps) {

    const [visibleVideos, setVisibleVideos] = useState(howManyItems)

    const loadMoreVideos = () => {
        setVisibleVideos(prevVisibleVideos => prevVisibleVideos + howManyItems)
    }

    return (
        <>
            
            {!disableDivider && (
                <SectionDivider />
            )}

            <Section className='list-videos'>
                <div className='container'>

                    {isNonWhitespaceString(title) && (
                        <h2 className='h1-hero-big list-videos__title'>
                            {title}
                        </h2>
                    )}

                    <div className='list-videos__grid'>
                        {videos.slice(0, visibleVideos).map((item, i) => (
                            <div key={i} className='shape-mask'>
                                <Video
                                    video={{
                                        playText: item.playText,
                                        videoType: item.videoType,
                                        poster: item.poster, // 600x400
                                        posterMedium: item.poster, // 600x400
                                        url: item.url,
                                        cookieConsentHtml: item.cookieConsentHtml,
                                    }}
                                />

                                {item.title && (
                                    <h3 className='h4'>
                                        {item.title}
                                    </h3>
                                )}

                            </div>
                        ))}
                    </div>

                    {bottomLink && bottomLink.hasPagination && visibleVideos < videos.length && (
                        <div className='list-videos__bottom-link'>
                            <Button
                                noUnderline
                                onClick={loadMoreVideos}
                            >
                                {bottomLink.text}
                            </Button>
                        </div>
                    )}

                    {bottomLink && !bottomLink.hasPagination && bottomLink.text && (
                        <div className='list-videos__bottom-link'>
                            <Button
                                noUnderline
                                href={bottomLink.href}
                                target={!!bottomLink.external}
                            >
                                {bottomLink.text}
                            </Button>
                        </div>
                    )}

                </div>
            </Section>

        </>
    )
}